import { Col, Row } from 'antd';
import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import { Card } from 'src/components/Card/Card';
import { DataView } from 'src/components/DataView/DataView';
import { MerchantSnapshotDto } from 'src/generated-api-client';

type LoanApplicationMerchantSnapshotBusinessInfoProps = {
    snapshot: MerchantSnapshotDto;
};

export const LoanApplicationMerchantSnapshotBusinessInfo = observer(
    ({ snapshot }: LoanApplicationMerchantSnapshotBusinessInfoProps) => {
        return (
            <Card
                title={t('LoanApplication.MerchantSnapshot.BusinessInfo.Title')}
            >
                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t(
                                'LoanApplication.MerchantSnapshot.BusinessInfo.JoiningDate',
                            )}
                            value={snapshot?.merchant?.joiningDate}
                            formatValue="date"
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t(
                                'LoanApplication.MerchantSnapshot.BusinessInfo.TenureDays',
                            )}
                            value={snapshot?.merchant?.tenureDays}
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t(
                                'LoanApplication.MerchantSnapshot.BusinessInfo.LastOrderDate',
                            )}
                            value={snapshot?.merchant?.lastOrderDate}
                            formatValue="date"
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t(
                                'LoanApplication.MerchantSnapshot.BusinessInfo.TotalBranches',
                            )}
                            value={snapshot?.merchant?.totalBranches}
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t(
                                'LoanApplication.MerchantSnapshot.BusinessInfo.TotalCustomers',
                            )}
                            value={snapshot?.merchant?.metrics?.totalCustomers}
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t(
                                'LoanApplication.MerchantSnapshot.BusinessInfo.TotalOrders',
                            )}
                            value={snapshot?.merchant?.metrics?.totalOrders}
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t(
                                'LoanApplication.MerchantSnapshot.BusinessInfo.TotalAmount',
                            )}
                            value={snapshot?.merchant?.metrics?.totalAmount}
                            formatValue="currency-sar"
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t(
                                'LoanApplication.MerchantSnapshot.BusinessInfo.AOV',
                            )}
                            value={snapshot?.merchant?.metrics?.aov}
                            formatValue="currency-sar"
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t(
                                'LoanApplication.MerchantSnapshot.BusinessInfo.OneTimeShare',
                            )}
                            value={snapshot?.merchant?.metrics?.oneTimeSharePct}
                            formatValue="percent"
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t(
                                'LoanApplication.MerchantSnapshot.BusinessInfo.RepeatShare',
                            )}
                            value={snapshot?.merchant?.metrics?.repeatSharePct}
                            formatValue="percent"
                        />
                    </Col>
                </Row>
            </Card>
        );
    },
);
